import React, { useState, useEffect, useCallback } from "react";
import { CircularProgress } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { getPaymentMethodChartDataAction } from "../../Actions/TransactionActions";
import NoDataFound from "./NoDataFound";
import { MyCancelIcon } from "../../Assets/svg/MyIcons";
import {Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend, Filler } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend, Filler);

const DashboardPaymentDistributionGraph = ({
  selectedMerchant,
  selectedWebsite,
  selectedTimeRange,
  startDate,
  endDate,
  showButton,
  onRemove,
  onShowSnackbar,
}) => {

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: ["#344D95", "#ffa726", "#ffca28"],
        borderWidth: 0,
        hoverOffset: 4,
      },
    ],
    totalAmount: [],
    avatars: [],
  });

  const [loading, setLoading] = useState(false);

  // Fetch chart data
  const fetchChartData = useCallback(async () => {
    setLoading(true);

    try {
      const response = await getPaymentMethodChartDataAction({
        startDate: startDate,
        endDate: endDate,
        merchant: selectedMerchant,
        chartType: selectedTimeRange,
        websiteId: selectedWebsite || null,
      });

      if (response?.data?.labels && response?.data?.data) {
        setChartData({
          labels: response.data.labels || [],
          datasets: [
            {
              data: response.data.data || [],
              backgroundColor: ["#344D95", "#ffa726", "#ffca28"],
              borderWidth: 0,
              hoverOffset: 4,
            },
          ],
          totalAmount: response.data.totalAmount || [],
          avatars: response.data.avatars || [],
        });
      } else {
        setChartData({
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor: ["#344D95", "#ffa726", "#ffca28"],
              borderWidth: 0,
              hoverOffset: 4,
            },
          ],
          totalAmount: [],
          avatars: [],
        });
      }
    } catch (error) {
      setChartData({
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: ["#344D95", "#ffa726", "#ffca28"],
            borderWidth: 0,
            hoverOffset: 4,
          },
        ],
        totalAmount: [],
        avatars: [],
      });
      if (error?.response?.data?.message) {
        onShowSnackbar(error.response.data.message, "error");
      }
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, selectedMerchant, selectedWebsite, selectedTimeRange, onShowSnackbar]);

  useEffect(() => {
    if (startDate && endDate) {
      fetchChartData();
    }
  }, [startDate, endDate, selectedMerchant, selectedWebsite, fetchChartData]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: { display: true, text: "Payment Method Distribution" },
    },
  };


  return (
    <div className={`kpi-card ${!showButton && "my-3"}`} key="paymentDistributionChart">
      {showButton && (
        <MyCancelIcon
          className="close-icon position-absolute cursor-pointer dash-close z-index-3"
          style={{ top: 5, right: 5 }}
          onClick={() => onRemove("paymentDistributionChart")}
        />
      )}

      <div className="kpi-card-content">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h2 className="chart-title m-0">Payment Method Distribution</h2>
        </div>

        <div className="chart-canvas-container" style={{ height: "350px" }}>
          {loading ? (
            <div className="chart-loading">
              <CircularProgress />
              <p>Loading payment method data...</p>
            </div>
          ) : chartData.datasets[0].data.length === 0 || chartData.datasets[0].data.every((value) => value === 0) ? (
            <NoDataFound message="No payment method data available" />
          ) : (
            <Doughnut data={chartData} options={chartOptions} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardPaymentDistributionGraph;